import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
export class AppService {
    constructor() {
        this.reloadData$ = new Subject();
    }
    reloadData() {
        this.reloadData$.next(true);
    }
    onReloadData() {
        return this.reloadData$.pipe(filter((val) => !!val));
    }
}
AppService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppService_Factory() { return new AppService(); }, token: AppService, providedIn: "root" });
